export default __webpack_public_path__ + "static/media/2.eb65e32b.png";